/**
 * Capitalizes the first character of a string (e.g. for enum display values).
 */
export function capitalizeFirst(s: string): string {
  if (!s || s.length === 0) return s;

  return s.charAt(0).toUpperCase() + s.slice(1);
}
